(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["yg-grid"] && !Shopify.designMode) return;
  try {
    
  class YgGrid extends HTMLElement {
    constructor() {
      super();
      this.abortController = null;
      this.observer = null;
      this.mobileQuery = window.matchMedia('(max-width: 767px)');
      this.handleMediaChange = this.handleMediaChange.bind(this);
    }

    connectedCallback() {
      this.abortController = new AbortController();
      this.items.forEach((item) => {
        item.addEventListener('mouseenter', () => {
          if (!this.isMobile) this.playItemVideo(item);
        }, { signal: this.abortController.signal });
        item.addEventListener('focusin', () => {
          if (!this.isMobile) this.playItemVideo(item);
        }, { signal: this.abortController.signal });
        item.addEventListener('mouseleave', () => {
          if (!this.isMobile) this.resetItemVideo(item);
        }, { signal: this.abortController.signal });
        item.addEventListener('focusout', () => {
          if (!this.isMobile) this.resetItemVideo(item);
        }, { signal: this.abortController.signal });
      });

      this.mobileQuery.addEventListener('change', this.handleMediaChange, { signal: this.abortController.signal });
      this.handleMediaChange();
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.destroyObserver();
      this.abortController = null;
    }

    get items() {
      return this.querySelectorAll('.yg-grid-item');
    }

    get isMobile() {
      return this.mobileQuery.matches;
    }

    handleMediaChange() {
      this.items.forEach((item) => this.resetItemVideo(item));

      if (this.isMobile) {
        this.createObserver();
      } else {
        this.destroyObserver();
      }
    }

    createObserver() {
      this.destroyObserver();
      if (!('IntersectionObserver' in window)) return;

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
            this.playItemVideo(entry.target);
          } else {
            this.resetItemVideo(entry.target);
          }
        });
      }, {
        rootMargin: '-20% 0px -20% 0px',
        threshold: [0, 0.6, 1]
      });

      this.items.forEach((item) => {
        if (item.querySelector('yg-video')) {
          this.observer.observe(item);
        }
      });
    }

    destroyObserver() {
      this.observer?.disconnect();
      this.observer = null;
    }

    getVisibleVideos(item) {
      return Array.from(item.querySelectorAll('video.yg-video-iframe')).filter((video) => {
        return video.offsetWidth > 0 && video.offsetHeight > 0;
      });
    }

    bindEndedOnce(item) {
      this.getVisibleVideos(item).forEach((video) => {
        if (video.dataset.ygGridEndedBound === 'true') return;
        video.dataset.ygGridEndedBound = 'true';
        video.addEventListener('ended', () => {
          if (video.loop) return;
          video.pause();
        });
      });
    }

    playItemVideo(item) {
      const ygVideo = item.querySelector('yg-video');
      if (!ygVideo || typeof ygVideo.playVideo !== 'function') return;
      if (item.dataset.ygGridPlaying === 'true') return;

      item.dataset.ygGridPlaying = 'true';
      ygVideo.loop = this.isMobile ? 'true' : 'false';
      ygVideo.playVideo();
      requestAnimationFrame(() => {
        this.bindEndedOnce(item);
        this.getVisibleVideos(item).forEach((video) => {
          video.loop = this.isMobile;
          video.muted = true;
          video.currentTime = 0;
          video.play().catch(() => {});
        });
      });
    }

    pauseItemVideo(item) {
      this.getVisibleVideos(item).forEach((video) => {
        if (!video.ended) {
          video.pause();
        }
      });
    }

    resetItemVideo(item) {
      item.classList.remove('is-video-playing');
      delete item.dataset.ygGridPlaying;
      const ygVideo = item.querySelector('yg-video');
      if (ygVideo) {
        ygVideo.loop = 'false';
      }
      this.getVisibleVideos(item).forEach((video) => {
        video.loop = false;
        video.pause();
        video.currentTime = 0;
      });
    }
  }

  if (!customElements.get('yg-grid')) {
    customElements.define('yg-grid', YgGrid);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-solution-tab"] && !Shopify.designMode) return;
  try {
    
  class YGSolutionTab extends HTMLElement {
    connectedCallback() {
      this.tablist = this.querySelector('[role="tablist"]');
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.selectTab(index));
        tab.addEventListener('keydown', (event) => this.onKeyDown(event, index));
      });

      this.addEventListener('click', (event) => this.onButtonLinkClick(event));
    }

    selectTab(index) {
      this.tabs.forEach((tab, tabIndex) => {
        const selected = tabIndex === index;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.setAttribute('tabindex', selected ? '0' : '-1');
        tab.classList.toggle('button--primary', !selected);
        tab.classList.toggle('button--secondary', selected);
      });

      this.panels.forEach((panel, panelIndex) => {
        const selected = panelIndex === index;
        panel.classList.toggle('is-active', selected);
        panel.hidden = !selected;
      });

      this.centerTab(index);
    }

    centerTab(index) {
      if (!this.tablist || !this.tabs[index] || !window.matchMedia('(max-width: 989px)').matches) {
        return;
      }

      const tab = this.tabs[index];
      const maxScroll = this.tablist.scrollWidth - this.tablist.clientWidth;
      const centeredLeft = tab.offsetLeft - (this.tablist.clientWidth - tab.offsetWidth) / 2;
      const left = Math.max(0, Math.min(centeredLeft, maxScroll));

      this.tablist.scrollTo({
        left,
        behavior: 'smooth'
      });
    }

    onKeyDown(event, index) {
      let nextIndex = index;

      if (event.key === 'ArrowRight') {
        nextIndex = (index + 1) % this.tabs.length;
      } else if (event.key === 'ArrowLeft') {
        nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
      } else if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = this.tabs.length - 1;
      } else {
        return;
      }

      event.preventDefault();
      this.selectTab(nextIndex);
      this.tabs[nextIndex].focus();
    }

    onButtonLinkClick(event) {
      const link = event.target.closest?.('.yg-solution-tab__button a[href]');
      if (!link || !this.contains(link) || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
        return;
      }

      const targetElement = this.getSamePageHashTarget(link);
      if (!targetElement) return;

      event.preventDefault();

      const url = new URL(link.href, window.location.href);
      history.pushState(null, '', `${url.pathname}${url.search}${url.hash}`);

      requestAnimationFrame(() => {
        const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

        if (targetElement === document.documentElement) {
          window.scrollTo({ top: 0, behavior });
          return;
        }

        targetElement.scrollIntoView({ behavior, block: 'start' });
      });
    }

    getSamePageHashTarget(link) {
      let url;

      try {
        url = new URL(link.href, window.location.href);
      } catch (error) {
        return null;
      }

      if (url.origin !== window.location.origin || url.pathname !== window.location.pathname || url.search !== window.location.search || !url.hash) {
        return null;
      }

      if (url.hash === '#') {
        return document.documentElement;
      }

      let targetId = url.hash.slice(1);

      try {
        targetId = decodeURIComponent(targetId);
      } catch (error) {}

      return document.getElementById(targetId) || document.getElementsByName(targetId)[0] || null;
    }
  }

  if (!customElements.get('yg-solution-tab')) {
    customElements.define('yg-solution-tab', YGSolutionTab);
  }

  } catch(e) { console.error(e); }
})();
})();
